import * as api from 'common/service/server-api';
import Jt from 'common/util/jt';
// import wxShare from 'common/service/wx-share';
import {inApp, artTypes, appName, appSlogan, appLogo} from 'common/constant';
import { clearTimeout } from 'timers';

const Jt_B = Jt.base;
const Jt_D = Jt.dom;

// 设置分享数据
function setShareData(data) {
    const imgs = data.imgUrl ? data.imgUrl.split(',http') : [];
    if(inApp && JSAPI.setShareContent) {
        // 华为端
        const shareData = {
            title: data.title || appName,
            desc: data.digest || appSlogan,
            url: data.detailUrl,
            wxthumb: imgs.length ? imgs[0] : appLogo
        };
        JSAPI.setShareContent(JSON.stringify(shareData));
    } else {
        // 普通WAP端
        // wxShare.setData({
        //     title: data.title,
        //     desc: data.digest,
        //     imgUrl: imgs.length ? imgs[0] : appLogo
        // });
    }
}

const detail = {
    state: {
        // 网络是否连接
        onLine: true,
        // 已完成的请求数
        endReqNum: 0,
        // 文章是否存在
        isExist: true,
        // 是否正在加载
        loading: false,
        // 普通正文
        normal: {},
        // 推荐
        rcmd: [],
        // 来源icon
        sourceIcon: null,
        // 广告信息
        item: {},
        version: Jt_B.getLocalData('lang')
    },
    mutations: {
        'detail:reset'(state) {
            state.onLine = true;
            state.endReqNum = 0;
            state.isExist = true;
            state.loading = false;
            state.normal = {};
            state.rcmd = [];
            state.sourceIcon = null;
        },
        'detail:update'(state, payload) {
            for(let key in payload) {
                state[key] = payload[key];
            }
        }
    },
    actions: {
        'detail:init'({commit, dispatch}, {id, messageFrom}) {
            commit('detail:reset');
            if (!id) {
                commit('detail:update', {isExist: false});
            } else {
                // 获取普通正文
                dispatch('detail:query:normal', {id, messageFrom});
            }
        },
        async 'detail:reload'({commit, dispatch}, {id, messageFrom}) {
            commit('detail:update', {loading: true});
            setTimeout(() => {
                dispatch('detail:query:normal', id);
            }, 3000);
        },
        'detail:query:normal'({ commit, dispatch, state }, {id, messageFrom}) {
            console.log(navigator)
            // if(typeof navigator.onLine !== 'undefined' && !navigator.onLine) {

            //     commit('detail:update', {onLine: false, isExist: false, loading: false});
            //     return;
            // }

            commit('detail:update', {loading: true});
            let code, data;
            if (messageFrom === 'zxb') { 
                api.getZxbDetail({id}, (res) => {
                    code = res.code;
                    data = res.data;
                    const payload = {onLine: true, loading: false, isExist: true, endReqNum: state.endReqNum + 1};
                    if(code === 0) {
                        if(!Jt_B.isEmpty(data)) {
                            const icon = data.icon;
                            let timer = null;
                            if(icon) {
                                delete data.icon;
                                // const image = new Image();
                                // let flag = false;
                                // image.onload = function() {
                                //     flag = true
                                //     commit('detail:update', {sourceIcon: icon});
                                // };
                                // clearTimeout(timer);
                                // timer = setTimeout(() => {
                                //     if (!flag) {
                                //         image.src = '';
                                //     }
                                // }, 2000);
                                // image.src = icon;
                            }
                            payload.normal = data;
                            // 获取推荐
                            // dispatch('detail:query:rcmd', id);
                            // 设置页面标题
                            Jt_D.setDocTitle(data.title);
                            // 设置分享数据
                            setShareData(data);
                        } else {
                            payload.isExist = false;
                            // 设置页面标题
                            Jt_D.setDocTitle('这篇文章找不到了');
                        }
                    } else {
                        payload.isExist = false;
                        // 设置页面标题
                        Jt_D.setDocTitle('这篇文章找不到了');
                    }
                    commit('detail:update', payload);
                });
            } else {
                api.getDetail({id}, (res) => {
                    code = res.code;
                    data = res.data;
                    const payload = {onLine: true, loading: false, isExist: true, endReqNum: state.endReqNum + 1};
                    if(code === 0) {
                        if(!Jt_B.isEmpty(data)) {
                            const icon = data.icon;
                            let timer = null;
                            if(icon) {
                                delete data.icon;
                                // const image = new Image();
                                // let flag = false;
                                // image.onload = function() {
                                //     flag = true
                                //     commit('detail:update', {sourceIcon: icon});
                                // };
                                // clearTimeout(timer);
                                // timer = setTimeout(() => {
                                //     if (!flag) {
                                //         image.src = '';
                                //     }
                                // }, 2000);
                                // image.src = icon;
                            }
                            payload.normal = data;
                            // 获取推荐
                            // dispatch('detail:query:rcmd', id);
                            // 设置页面标题
                            Jt_D.setDocTitle(data.title);
                            // 设置分享数据
                            setShareData(data);
                        } else {
                            payload.isExist = false;
                            // 设置页面标题
                            Jt_D.setDocTitle('这篇文章找不到了');
                        }
                    } else {
                        payload.isExist = false;
                        // 设置页面标题
                        Jt_D.setDocTitle('这篇文章找不到了');
                    }
                    commit('detail:update', payload);
                });
            }
        },
        async 'detail:query:rcmd'({commit, state}, id) {
            const {code, data} = await api.getRcmd({id});
            const payload = {rcmd: [], endReqNum: state.endReqNum + 1};
            if(code === 0) {
                if(data && data.length) {
                    payload.rcmd = data;
                }
            }
            commit('detail:update', payload);
        }
    },
    getters: {
        'detail:onLine'(state) {
            return state.onLine;
        },
        'detail:endReqNum'(state) {
            return state.endReqNum;
        },
        'detail:isExist'(state) {
            return state.isExist;
        },
        'detail:loading'(state) {
            return state.loading;
        },
        'detail:normal'(state) {
            return state.normal;
        },
        'detail:rcmd'(state) {
            const normal = state.normal || {};
            let rcmd = state.rcmd || [];
            const type = artTypes[normal.type] || 'normal';
            switch(type) {
                case 'image' :
                    if(normal.ad) {
                        rcmd = rcmd.slice(0, 4);
                    } else {
                        rcmd = rcmd.slice(0, 6);
                    }
                    break;
            }
            return rcmd;
        },
        'detail:sourceIcon'(state) {
            return state.sourceIcon;
        },
        'detail:version'(state) {
            return state.version
        }
    }
};

export default detail;



// WEBPACK FOOTER //
// ./src/common/store/module/detail.js